export const updateTagFormList = (category, newTagObjectArray, setters) => {
  const tagNames = newTagObjectArray.map(x => x.isNewOption ? `is-new-option--${x.name}` : x.name);
  const setList = setters[category];
  if (setList) setList(tagNames);
  else console.warn(`No setter found for category: ${category}`);
};

export const createNewObjects = (list, category) => {
  const output = list.filter(x => x.includes('is-new-option--')).map(x => ({ name: x.replace('is-new-option--', ''), ...(category && { category }) }));
  return output;
}
